export default "__VITE_ASSET__l8qPcHpl__"